export const portalTicketKindTranslations = {
  de: {
    intro: 'Anliegen auswählen', title: 'Wie können wir Ihnen helfen?',
    hint: 'Wählen Sie zuerst Ihr Anliegen. Wir führen Sie danach durch die passenden Schritte.',
    incident: 'Störungsmeldung',
    incident_hint: 'Etwas funktioniert nicht oder fällt aus. Melden Sie ein Problem mit einem Gerät, einer Anwendung oder einem Dienst.',
    request_hint: 'Sie benötigen Unterstützung, Informationen oder eine neue Leistung. Wählen Sie die passende Anfrageart und füllen Sie ihr Formular aus.',
    incident_action: 'Störung melden', request_action: 'Anfrage auswählen', change: 'Art ändern', back: 'Zurück zur Auswahl',
  },
  en: {
    intro: 'Choose your topic', title: 'How can we help you?',
    hint: 'Choose your topic first. We will guide you through the appropriate steps.',
    incident: 'Report an incident',
    incident_hint: 'Something is not working or is unavailable. Report a problem with a device, application or service.',
    request_hint: 'You need assistance, information or a new service. Choose the appropriate request type and complete its form.',
    incident_action: 'Report an incident', request_action: 'Choose a request', change: 'Change type', back: 'Back to selection',
  },
  fr: {
    intro: 'Choisir votre sujet', title: 'Comment pouvons-nous vous aider ?',
    hint: 'Choisissez d’abord votre sujet. Nous vous guiderons ensuite dans les étapes adaptées.',
    incident: 'Signaler un incident',
    incident_hint: 'Un élément ne fonctionne pas ou est indisponible. Signalez un problème avec un appareil, une application ou un service.',
    request_hint: 'Vous avez besoin d’aide, d’informations ou d’un nouveau service. Choisissez le type de demande et remplissez son formulaire.',
    incident_action: 'Signaler un incident', request_action: 'Choisir une demande', change: 'Changer de type', back: 'Retour au choix',
  },
  es: {
    intro: 'Seleccione el motivo', title: '¿Cómo podemos ayudarle?',
    hint: 'Seleccione primero el motivo. Le guiaremos por los pasos correspondientes.',
    incident: 'Notificar una incidencia',
    incident_hint: 'Algo no funciona o no está disponible. Notifique un problema con un dispositivo, una aplicación o un servicio.',
    request_hint: 'Necesita ayuda, información o un nuevo servicio. Seleccione el tipo de solicitud y complete su formulario.',
    incident_action: 'Notificar incidencia', request_action: 'Elegir solicitud', change: 'Cambiar tipo', back: 'Volver a la selección',
  },
  ru: {
    intro: 'Выберите тему', title: 'Чем мы можем помочь?',
    hint: 'Сначала выберите тему обращения. Затем мы проведём вас по соответствующим шагам.',
    incident: 'Сообщить о неисправности',
    incident_hint: 'Что-то не работает или недоступно. Сообщите о проблеме с устройством, приложением или сервисом.',
    request_hint: 'Вам нужна помощь, информация или новая услуга. Выберите тип запроса и заполните соответствующую форму.',
    incident_action: 'Сообщить о проблеме', request_action: 'Выбрать запрос', change: 'Изменить тип', back: 'Назад к выбору',
  },
  pt: {
    intro: 'Escolha o assunto', title: 'Como podemos ajudar?',
    hint: 'Escolha primeiro o assunto. Vamos guiá-lo pelos passos adequados.',
    incident: 'Comunicar uma ocorrência',
    incident_hint: 'Algo não funciona ou está indisponível. Comunique um problema com um dispositivo, uma aplicação ou um serviço.',
    request_hint: 'Precisa de assistência, informações ou de um novo serviço. Escolha o tipo de pedido e preencha o respetivo formulário.',
    incident_action: 'Comunicar ocorrência', request_action: 'Escolher pedido', change: 'Alterar tipo', back: 'Voltar à seleção',
  },
  pl: {
    intro: 'Wybierz temat', title: 'Jak możemy pomóc?',
    hint: 'Najpierw wybierz temat. Następnie przeprowadzimy Cię przez odpowiednie kroki.',
    incident: 'Zgłoś awarię',
    incident_hint: 'Coś nie działa lub jest niedostępne. Zgłoś problem z urządzeniem, aplikacją lub usługą.',
    request_hint: 'Potrzebujesz pomocy, informacji lub nowej usługi. Wybierz rodzaj wniosku i wypełnij odpowiedni formularz.',
    incident_action: 'Zgłoś awarię', request_action: 'Wybierz wniosek', change: 'Zmień rodzaj', back: 'Wróć do wyboru',
  },
  nl: {
    intro: 'Kies uw onderwerp', title: 'Hoe kunnen we u helpen?',
    hint: 'Kies eerst uw onderwerp. Daarna begeleiden we u door de juiste stappen.',
    incident: 'Storing melden',
    incident_hint: 'Iets werkt niet of is niet beschikbaar. Meld een probleem met een apparaat, toepassing of dienst.',
    request_hint: 'U heeft ondersteuning, informatie of een nieuwe dienst nodig. Kies het juiste verzoektype en vul het formulier in.',
    incident_action: 'Storing melden', request_action: 'Verzoek kiezen', change: 'Type wijzigen', back: 'Terug naar de keuze',
  },
  be: {
    intro: 'Kies uw onderwerp', title: 'Hoe kunnen we u helpen?',
    hint: 'Kies eerst uw onderwerp. Daarna begeleiden we u door de juiste stappen.',
    incident: 'Storing melden',
    incident_hint: 'Iets werkt niet of is niet beschikbaar. Meld een probleem met een toestel, toepassing of dienst.',
    request_hint: 'U heeft ondersteuning, informatie of een nieuwe dienst nodig. Kies het juiste aanvraagtype en vul het formulier in.',
    incident_action: 'Storing melden', request_action: 'Aanvraag kiezen', change: 'Type wijzigen', back: 'Terug naar de keuze',
  },
};
